import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import ParticlesAuth from "../ParticlesAuth";

// Import Images
import error from "../../../assets/images/error.svg";
import UiContent from '../../../Components/Common/UiContent';
import { useLoggedUser } from '../../../Components/Hooks/useUserHooks';
import useQuery from '../../../Components/Hooks/useQuery';

const Basic403 = () => {

    const query = useQuery(); // Get query from route
    const noRedirectHome = query.get("noRedirectHome"); // Flag no redirect home
    return (

        <React.Fragment>
            <UiContent />
            <div className="page-content mb-10">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center pt-4">
                                <div className="">
                                    <img src={error} alt="" style={{ height: '20em' }} className="error-basic-img move-animation" />
                                </div>
                                <div className="mt-n4">
                                    <div className="mt-n4 text-center">
                                        <h1 className="display-1 fw-semibold">403</h1>
                                        <h3 className="text-uppercase">Acceso restringido</h3>
                                        <p className="text-muted mb-4">
                                            El recurso al que intentas acceder se encuentra restringido
                                        </p>
                                    </div>
                                    {
                                        !noRedirectHome == true ?
                                            (
                                                <Link to="/dashboard" className="btn btn-success"><i className="mdi mdi-home me-1"></i>Volver al inicio</Link>
                                            ) : null
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div >
        </React.Fragment >
    );
};

export default Basic403;